import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import "./Filter.css";

const DeleteFilterDialog = ({
  visible,
  onHide,
  filter,
  onConfirm,
  loading,
}) => {
  const dialogFooter = (
    <div className="flex justify-content-end gap-2">
      <Button
        label="Cancel"
        icon="pi pi-times"
        onClick={onHide}
        className="p-button-text"
        disabled={loading}
      />
      <Button
        label="Delete"
        icon="pi pi-trash"
        onClick={onConfirm}
        style={{ backgroundColor: "#dc3545", borderColor: "#dc3545" }}
        loading={loading}
      />
    </div>
  );

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header="Confirm Delete"
      style={{ width: "450px" }}
      modal
      footer={dialogFooter}
    >
      <div className="flex align-items-center gap-3">
        <i
          className="pi pi-exclamation-triangle"
          style={{ fontSize: "2rem", color: "#dc3545" }}
        />
        <div>
          <p className="m-0">
            Are you sure you want to delete the filter{" "}
            <strong>"{filter?.name}"</strong>?
          </p>
          <p
            className="mt-2 mb-0"
            style={{ fontSize: "0.9rem", color: "#666" }}
          >
            This action cannot be undone.
          </p>
        </div>
      </div>
    </Dialog>
  );
};

export default DeleteFilterDialog;
